// src/icons/svgs/align-text-left.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgAlignTextLeft = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 18, fill: "none", viewBox: "0 0 24 18", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.364.818a.818.818 0 1 0 0 1.636h21.273a.818.818 0 1 0 0-1.636zm0 4.91a.818.818 0 1 0 0 1.636H17.91a.818.818 0 0 0 0-1.637zm-.818 5.727c0-.452.366-.819.818-.819h21.273a.818.818 0 1 1 0 1.637H1.364a.82.82 0 0 1-.818-.819m.818 4.09a.818.818 0 1 0 0 1.637H17.91a.818.818 0 0 0 0-1.637z", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgAlignTextLeft);
var align_text_left_default = ForwardRef;
export {
  align_text_left_default as TextAlignLeft
};
